import { Injectable } from "@angular/core";
import { resolveApiUrl } from "./api-url";

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  public apiUrl = resolveApiUrl();
}
